import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const { currentLanguage } = useLanguage();

  const phoneNumber = '351936447633';
  
  const messages = {
    pt: 'Olá! Gostaria de saber mais sobre os vossos serviços de wedding planning.',
    en: 'Hello! I would like to know more about your wedding planning services.',
    fr: 'Bonjour! Je voudrais en savoir plus sur vos services de wedding planning.',
    es: '¡Hola! Me gustaría saber más sobre vuestros servicios de wedding planning.'
  };

  const tooltips = {
    pt: 'Fale connosco!',
    en: 'Talk to us!',
    fr: 'Parlez-nous!',
    es: '¡Hable con nosotros!'
  };

  useEffect(() => {
    // Show button after 2 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    // Show tooltip after 5 seconds
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
      // Hide tooltip after 5 seconds
      setTimeout(() => setShowTooltip(false), 5000);
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  const handleClick = () => {
    const message = encodeURIComponent(messages[currentLanguage] || messages.pt);
    // Use the direct WhatsApp link format that works better across devices
    const whatsappUrl = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
    const mobileUrl = `whatsapp://send?phone=${phoneNumber}&text=${message}`;
    
    // Check if mobile
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (isMobile) {
      window.location.href = mobileUrl;
    } else {
      window.open(whatsappUrl, '_blank');
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-3">
      {/* Tooltip */}
      {showTooltip && (
        <div className="animate-fade-in bg-white rounded-lg shadow-lg px-4 py-2 text-sm text-[#2C2C2C] flex items-center gap-2">
          <span>{tooltips[currentLanguage] || tooltips.pt}</span>
          <button 
            onClick={() => setShowTooltip(false)}
            className="text-[#8B7D6B] hover:text-[#2C2C2C]"
          >
            <X size={14} />
          </button>
        </div>
      )}
      
      {/* WhatsApp Button */}
      <button
        onClick={handleClick}
        className="group w-14 h-14 bg-[#25D366] rounded-full shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-300 hover:scale-110 relative"
        aria-label="Contactar via WhatsApp"
        data-testid="whatsapp-btn"
      >
        <MessageCircle 
          size={28} 
          className="text-white fill-white" 
        />
        
        {/* Pulse animation */}
        <span className="absolute w-14 h-14 bg-[#25D366] rounded-full animate-ping opacity-30" />
      </button>
    </div>
  );
};

export default WhatsAppButton;
